import { render } from "./ModuleAggregatePublication.vue?vue&type=template&id=6e52374a&scoped=true"
import script from "./ModuleAggregatePublication.vue?vue&type=script&lang=js"
export * from "./ModuleAggregatePublication.vue?vue&type=script&lang=js"

import "./ModuleAggregatePublication.vue?vue&type=style&index=0&id=6e52374a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e52374a"]])

export default __exports__